import editStyles from "../../../styles/editForm.module.css";

export function withInputError(base: string, hasError: boolean): string {
  return hasError ? `${base} ${editStyles.inputError}` : base;
}

export function inputErrorClass(hasError: boolean): string {
  return hasError ? editStyles.inputError : "";
}
